import { ArrowRight, Check } from 'lucide-react';
import { useLang } from '@/context/LangContext';

const OWAPage = () => {
  const { t } = useLang();
  return (
    <div className="min-h-screen bg-white pt-24">
      {/* Hero */}
      <section className="py-24 md:py-32 bg-gradient-to-br from-white via-[#FDFBF7] to-[#F8F0E3]" data-testid="owa-hero">
        <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
          <p className="text-xs uppercase tracking-[0.25em] font-medium text-[#C19B76] mb-4">{t.owa_intro.overline}</p>
          <h1 className="text-5xl sm:text-6xl font-light tracking-tight text-[#0A0A0A] mb-6">{t.owa_intro.title}</h1>
          <p className="text-lg font-light text-[#555] mb-10 max-w-2xl mx-auto">{t.owa_intro.desc}</p>
          <a href="https://aurem8.tentary.com/" target="_blank" rel="noopener noreferrer" className="inline-flex bg-[#C19B76] text-white rounded-full px-10 py-4 font-medium hover:bg-[#A6825B] transition-colors items-center gap-2" data-testid="owa-cta">
            {t.hero.cta}<ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </section>

      {/* Features */}
      <section className="py-24 md:py-32 bg-white" data-testid="owa-features">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {t.owa_intro.features.map((f, i) => (
              <div key={i} className="flex items-start gap-3 bg-[#FDFBF7] rounded-2xl p-6 border border-[#C19B76]/10">
                <Check className="w-5 h-5 text-[#C19B76] mt-0.5 flex-shrink-0" strokeWidth={2} />
                <span className="text-sm text-[#444] leading-relaxed">{f}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Digital Products */}
      <section className="py-24 md:py-32 bg-[#FDFBF7]" data-testid="owa-digital">
        <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
          <p className="text-xs uppercase tracking-[0.25em] font-medium text-[#C19B76] mb-4">{t.digital.overline}</p>
          <h2 className="text-4xl sm:text-5xl font-light tracking-tight text-[#0A0A0A] mb-6">{t.digital.title}</h2>
          <p className="text-lg font-light text-[#555] mb-10">{t.digital.desc}</p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {t.digital.items.map((item, i) => (
              <div key={i} className="bg-white rounded-2xl p-5 border border-[#C19B76]/10">
                <span className="text-sm font-medium text-[#333]">{item}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* MRR */}
      <section className="py-24 md:py-32 bg-white" data-testid="owa-mrr">
        <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
          <p className="text-xs uppercase tracking-[0.25em] font-medium text-[#C19B76] mb-4">{t.mrr.overline}</p>
          <h2 className="text-4xl sm:text-5xl font-light tracking-tight text-[#0A0A0A] mb-6">{t.mrr.title}</h2>
          <p className="text-lg font-light text-[#555]">{t.mrr.desc}</p>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 md:py-32 bg-[#0A0A0A]" data-testid="owa-final-cta">
        <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
          <h2 className="text-4xl sm:text-5xl font-light tracking-tight text-white mb-6">{t.cta_section.title}</h2>
          <p className="text-lg font-light text-white/60 mb-10">{t.cta_section.desc}</p>
          <a href="https://aurem8.tentary.com/" target="_blank" rel="noopener noreferrer" className="inline-flex bg-[#C19B76] text-white rounded-full px-10 py-4 font-medium hover:bg-[#A6825B] transition-colors items-center gap-2" data-testid="owa-final-btn">
            {t.cta_section.btn}<ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </section>
    </div>
  );
};

export default OWAPage;
